import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  // Render the dashboard with a clear banner instead of crashing — useful
  // when someone clones the repo and hasn't set .env yet.
  console.warn("[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing");
}

export const supabase = createClient(url || "https://invalid", key || "anon-missing", {
  auth: { persistSession: false },
});

export const supabaseConfigured = Boolean(url && key);

// --- table row types -----------------------------------------------------

export type ApprovalStatus = "pending" | "approved" | "rejected";

export interface PublishedPost {
  id: string;
  item_id: string | null;
  lane: number | null;
  tier: string | null;
  style: string | null;
  title: string | null;
  source_url: string | null;
  synth_at: string | null;
  content_preview: string | null;
  approval_status: ApprovalStatus;
  approval_notes: string | null;
  reviewed_at: string | null;
  created_at: string;
}

export interface CostLogRow {
  id: string;
  item_id: string | null;
  lane: number | null;
  model: string | null;
  backend: string | null;
  input_tokens: number;
  output_tokens: number;
  cache_read_input_tokens: number;
  duration_ms: number;
  cost_usd: number;
  logged_at: string | null;
  created_at: string;
}

export interface AdapterPublishRow {
  id: string;
  adapter: string | null;
  external_id: string | null;
  private_url: string | null;
  status: string | null;
  published_at: string | null;
  created_at: string;
}

export interface SourceHealthRow {
  id: string;
  checked_at: string | null;
  source_name: string | null;
  status: string | null;
  error_message: string | null;
  created_at: string;
}
